import { ApiResponse, Station } from "../types/api";
import { http } from "./http";

export const listStations = async (): Promise<Station[]> => {
  const { data } = await http.get<ApiResponse<Station[]>>("/stations");
  if (!data.success || !data.data) throw new Error(data.error || "Load stations failed");
  return data.data;
};

export const getStation = async (id: number): Promise<Station> => {
  const { data } = await http.get<ApiResponse<Station>>(`/stations/${id}`);
  if (!data.success || !data.data) throw new Error(data.error || "Load station failed");
  return data.data;
};


export const createStation = async (station: Omit<Station, "id">): Promise<Station> => {
  const { data } = await http.post<ApiResponse<Station>>("/stations", station);
  if (!data.success || !data.data) throw new Error(data.error || "Create station failed");
  return data.data;
};


export const updateStation = async (id: number, station: Partial<any>): Promise<Station> => {
  const { data } = await http.put<ApiResponse<Station>>(`/stations/${id}`, station);
  if (!data.success || !data.data) throw new Error(data.error || "Update station failed");
  return data.data;
};


export const deleteStation = async (id: number): Promise<void> => {
  const { data } = await http.delete<ApiResponse<null>>(`/stations/${id}`);
  if (!data.success) throw new Error(data.error || "Delete station failed");
};
